// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: white ;
    font-size: 16px;
    border-bottom: 2px solid white;
}

.custom-tabs .ant-tabs-ink-bar {
    display: none;
}


.question-text {
    flex: 1;
    min-width: 0; 
    white-space: pre-wrap; 
}

.input-container {
    display: flex;
    flex-direction: column;
    gap: 8px; 
    align-items: center; 
}

.custom-tabs .ant-tabs-nav {
    background-color: #014D4E;
    height: 45px;
    border-radius: 15px 15px 0 0; 
}

.custom-tabs .ant-tabs-tab {

    align-items: center;
    color: white;
    font-size: 18px;
    padding: 0 20px !important;
    margin: 0 !important;

}

.custom-tabs .ant-tabs-tab-active {
    color: white ;
}

.custom-select .ant-select-selector {
    height: 28px !important;
    border: 0 !important;
    border-bottom: 1px dotted #000; 
  }


  @media (max-width: 768px) {
    .form-item-label {
      font-size: 0.875rem; 
      flex: 0 0 2rem; 
    }
  
    .form-item-content {
      flex-direction: column; 
      align-items: flex-start;
    }
  
    .form-item-input {
      width: 100%; 
    }
  
    .toggle-button {
      width: 100%; 
    }
  }
  
  @media (max-width: 576px) {
    .form-item-label {
      font-size: 0.75rem; 
    }
  
    .form-item-input .ant-input,
    .form-item-input .ant-picker {
      width: 100%;
    }
  
    .toggle-button {
      width: 100%;
    }
  }

  .ant-select-selector {
    outline: none !important;
    box-shadow: none !important;
  }
`, "",{"version":3,"sources":["webpack://./src/pages/Supplier/supplierGoals/Goals.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,OAAO;IACP,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,oBAAoB;;AAExB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,8BAA8B;EAChC;;;EAGA;IACE;MACE,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;IACzB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,WAAW;IACb;EACF;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;;MAEE,WAAW;IACb;;IAEA;MACE,WAAW;IACb;EACF;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;EAC7B","sourcesContent":[".custom-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: white ;\n    font-size: 16px;\n    border-bottom: 2px solid white;\n}\n\n.custom-tabs .ant-tabs-ink-bar {\n    display: none;\n}\n\n\n.question-text {\n    flex: 1;\n    min-width: 0; \n    white-space: pre-wrap; \n}\n\n.input-container {\n    display: flex;\n    flex-direction: column;\n    gap: 8px; \n    align-items: center; \n}\n\n.custom-tabs .ant-tabs-nav {\n    background-color: #014D4E;\n    height: 45px;\n    border-radius: 15px 15px 0 0; \n}\n\n.custom-tabs .ant-tabs-tab {\n\n    align-items: center;\n    color: white;\n    font-size: 18px;\n    padding: 0 20px !important;\n    margin: 0 !important;\n\n}\n\n.custom-tabs .ant-tabs-tab-active {\n    color: white ;\n}\n\n.custom-select .ant-select-selector {\n    height: 28px !important;\n    border: 0 !important;\n    border-bottom: 1px dotted #000; \n  }\n\n\n  @media (max-width: 768px) {\n    .form-item-label {\n      font-size: 0.875rem; \n      flex: 0 0 2rem; \n    }\n  \n    .form-item-content {\n      flex-direction: column; \n      align-items: flex-start;\n    }\n  \n    .form-item-input {\n      width: 100%; \n    }\n  \n    .toggle-button {\n      width: 100%; \n    }\n  }\n  \n  @media (max-width: 576px) {\n    .form-item-label {\n      font-size: 0.75rem; \n    }\n  \n    .form-item-input .ant-input,\n    .form-item-input .ant-picker {\n      width: 100%;\n    }\n  \n    .toggle-button {\n      width: 100%;\n    }\n  }\n\n  .ant-select-selector {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
